import React, { useState } from "react";
import { Link } from "react-router-dom";
import FormSec from "./FormSec";
import RegisterForm from "./RegisterForm";
import StarryNightSky from "./Stars";
import Navbar from "./Navbar";

import { useNavigate } from "react-router-dom";

const GetEarlyAccess = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return (
    <>
      <div className="h-full w-full bg-black text-white  md:p-12 flex-col justify-center">
        <Navbar
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
        />
        <StarryNightSky height="100vh" />
        <div className="flex flex-col mx-auto md:max-w-5xl ">



          <div className="w-screen flex flex-col gap-12 px-8 pt-10 md:flex-row md:w-full">

            <div className="flex flex-col gap-8">
              <h1 className="text-3xl md:text-5xl font-bold mb-4">
                🚀 Be the First to Shape the Future of the Coal Industry
              </h1>
              <p className="text-lg md:text-xl mb-4">
                We're building something game-changing, and we want you to be
                part of it.
              </p>
              <p className="text-lg md:text-xl mb-8">
                Join our Early Access Program to get exclusive access to the
                first version of our app designed to automate, secure, and
                modernize operations in the coal industry.
              </p>
            </div>

            <div className=" flex items-center justify-center md:flex-shrink-0 md:w-[400px] h-[400px]">
              <img
                src="/getearly.png"
                alt="Get early access"
                className="w-[400px] h-[400px]"
              />
            </div>
          </div>
          <div className="rounded-2xl p-6 md:p-8 shadow-lg  mb-8">
            <h2 className="text-2xl font-semibold mb-4">
              As an early user, you'll have the opportunity to:
            </h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <img
                  src="/mdi_shieldtick.png"
                  className="text-indigo-500 w-6 h-6 mr-3"
                />
                <span>Test core features before public release</span>
              </li>
              <li className="flex items-start">
                <img
                  src="/mdi_shieldtick.png"
                  className="text-indigo-500 w-6 h-6 mr-3"
                />
                <span>
                  Share your insights and feedback to shape product development
                </span>
              </li>
              <li className="flex items-start">
                <img
                  src="/mdi_shieldtick.png"
                  className="text-indigo-500 w-6 h-6 mr-3"
                />
                <span>Get early-bird discounts (Terms & Conditions apply)</span>
              </li>
              <li className="flex items-start">
                <img
                  src="/mdi_shieldtick.png"
                  className="text-indigo-500 w-6 h-6 mr-3"
                />
                <span>Collaborate directly with our product team</span>
              </li>
            </ul>
          </div>

          <p className="text-lg px-8 md:text-xl">
            If you're passionate about making the coal industry smarter, safer,
            and more efficient—now is the time to get involved.
          </p>
        </div>
      </div>

      <RegisterForm />
    </>
  );
};

export default GetEarlyAccess;
